import { FuturesOrderType } from '@kwenta/sdk/types'

import { FetchStatus } from './types'

export const ZERO_STATE_TRADE_INPUTS = {
	nativeSize: '',
	susdSize: '',
	orderType: 'market' as FuturesOrderType,
	orderPrice: {
		price: undefined,
		invalidLabel: undefined,
	},
}

export const ZERO_CM_FEES = {
	delayedOrderFee: '0',
	keeperEthDeposit: '0',
}

export const ZERO_STATE_ISOLATED_ACCOUNT = {
	position: undefined,
	trades: [],
	marketMarginTransfers: [],
	positions: [],
	delayedOrders: [],
	positionHistory: [],
}

export const ZERO_STATE_ACCOUNT = {
	position: undefined,
	balanceInfo: {
		freeMargin: '0',
		allowance: '0',
		keeperEthBal: '0',
		walletEthBal: '0',
		balances: { SUSD: '0', USDC: '0', DAI: '0' },
		allowances: { SUSD: '0', USDC: '0', DAI: '0' },
	},
	trades: [],
	liquidations: [],
	positions: [],
	accountTransfers: [],
	delayedOrders: [],
	conditionalOrders: [],
	positionHistory: [],
	delegates: [],
	subAccounts: [],
	orderHistory: [],
}

export const ZERO_STATE_MARGIN_INFO = {
	availableMargin: '0',
	withdrawableMargin: '0',
	requiredMaintenanceMargin: '0',
	requiredInitialMargin: '0',
	maxLiquidationReward: '0',
}

export const ZERO_STATE_CM_ACCOUNT = {
	...ZERO_STATE_ACCOUNT,
	balances: {},
	pendingAsyncOrder: undefined,
	collateralBalances: {},
	usdcBalance: '0',
	pnlSnapshots: [],
	marginSnapshots: {
		ONE_YEAR: [],
		ONE_MONTH: [],
		ONE_WEEK: [],
	},
	marginInfo: {
		...ZERO_STATE_MARGIN_INFO,
	},
}

export const DEFAULT_QUERY_STATUS = {
	status: FetchStatus.Idle,
	error: null,
}

export const LOADING_STATUS = {
	status: FetchStatus.Loading,
	error: null,
}

export const SUCCESS_STATUS = {
	status: FetchStatus.Success,
	error: null,
}

export const DEFAULT_MAP_BY_NETWORK = {
	11155420: {},
	10: {},
	84532: {},
}

export const KEEPER_ETH_GAS_FEE = 0.002
export const KEEPER_USD_GAS_FEE = 2

export const DEFAULT_SWAP_SLIPPAGE = 0.5
